import { XMarkIcon } from "@heroicons/react/24/solid";
import { useTranslation } from "react-i18next";
import avatar from "../../assets/images/Avatar.avif";
import SectionLoader from "../sharedComponents/Loading/SectionLoader";

const ReviewDetailsModal = ({ isOpen, onClose, review }) => {
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === "ar";

    return (
        <div
            className={`fixed inset-0 z-[999] flex items-center justify-center transition-all duration-300 ${isOpen ? "visible" : "invisible"
                }`}
        >
            {/* Overlay */}
            <div
                onClick={onClose}
                className={`absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300 ${isOpen ? "opacity-100" : "opacity-0"
                    }`}
            />

            {/* Modal */}
            <div
                className={`relative z-10 w-full max-w-lg mx-4 p-5 rounded-2xl bg-white dark:bg-bg-dark-secondary shadow-xl transform transition-all duration-300 ${isOpen ? "opacity-100 scale-100" : "opacity-0 scale-95"
                    }`}
            >
                {!review ? (
                    <SectionLoader />
                ) : (
                    <>
                        {/* Header */}
                        <div className="flex items-center justify-between mb-4">
                            <h2 className="text-xl font-semibold text-black dark:text-white">
                                {t("reviewDetails.title")}
                            </h2>
                            <button onClick={onClose}>
                                <XMarkIcon className="w-6 h-6 text-gray-400 hover:text-black dark:hover:text-white" />
                            </button>
                        </div>

                        {/* Company Info */}
                        <div className="flex items-center gap-3 mb-4">
                            <img
                                src={review?.Company?.logo}
                                className="object-cover w-12 h-12 rounded-full"
                                alt={review?.Company?.name_EN}
                            />
                            <div>
                                <p className="font-semibold text-black dark:text-white">
                                    {isArabic
                                        ? review?.Company?.name_AR
                                        : review?.Company?.name_EN}
                                </p>
                                <p className="text-sm text-gray-500">
                                    {t("reviewDetails.company")}
                                </p>
                            </div>
                        </div>

                        {/* User Info */}
                        <div className="flex items-center gap-3 mb-4">
                            <img
                                src={review?.User?.avatar || avatar}
                                className="w-10 h-10 rounded-full"
                                alt={review?.User?.fullName}
                            />
                            <div>
                                <p className="font-medium text-black dark:text-white">
                                    {review?.User?.fullName}
                                </p>
                                <p className="text-sm text-gray-500">
                                    @{review?.User?.code}
                                </p>
                                <p className="text-sm text-gray-500">
                                    {t("reviewDetails.email")}: {review?.User?.email}
                                </p>
                                <p className="text-sm text-gray-500">
                                    {t("reviewDetails.phone")}: {review?.User?.phone}
                                </p>
                            </div>
                        </div>

                        {/* Rating */}
                        <div className="flex items-center gap-2 mb-4">
                            <span className="text-lg text-yellow-500">
                                {"⭐".repeat(review?.rating || 0)}
                            </span>
                            <span className="text-gray-600 dark:text-gray-300">
                                {t("reviewDetails.rating")} ({review?.rating}/5)
                            </span>
                        </div>

                        {/* Review Text */}
                        <div className="p-3 mb-4 rounded-lg bg-gray-50 dark:bg-bg-dark-primary">
                            <p className="text-gray-800 dark:text-gray-200">
                                {review?.text}
                            </p>
                        </div>

                        {/* Status */}
                        <div className="mb-3">
                            {review?.isActive ? (
                                <span className="px-3 py-1 text-xs text-green-600 bg-green-100 rounded-xl">
                                    {t("reviewDetails.active")}
                                </span>
                            ) : (
                                <span className="px-3 py-1 text-xs text-red-600 bg-red-100 rounded-xl">
                                    {t("reviewDetails.inactive")}
                                </span>
                            )}
                        </div>

                        {/* Date */}
                        <div className="text-xs text-gray-400">
                            {t("reviewDetails.createdAt")}:{" "}
                            {new Date(review?.createdAt).toLocaleString(
                                i18n.language
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ReviewDetailsModal;